var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5TransitionInsufficient = function SvgAv5TransitionInsufficient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E3A446",
    "data-no-fill": "true",
    "data-no-stroke": "true"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5a3 3 270 1 1 3 4v1.5M8 13h0",
    stroke: "#fff",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    "data-no-fill": "true"
  })));
};
export { SvgAv5TransitionInsufficient as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQogICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiNFM0E0NDYiIGRhdGEtbm8tZmlsbD0idHJ1ZSIgZGF0YS1uby1zdHJva2U9InRydWUiLz4NCiAgICA8cGF0aA0KICAgICAgICBkPSJNNSw1IEEzIDMgMjcwIDEgMSA4LDkgTDgsMTAuNSBNOCwxMyBsMCwwIiBzdHJva2U9IiNmZmYiDQogICAgICAgIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiDQogICAgICAgIGZpbGw9Im5vbmUiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPg0KPC9zdmc+";